export default "__VITE_ASSET__c2df41bc__"